@if(url) {
    <iframe [src]="url"></iframe>
} @else {
    <mat-spinner></mat-spinner>
}